import React from "react";
import { Carousel } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import SliderImage from "../images/norvicHospital1.jpeg";
import SliderImage2 from "../images/norvicHospital2.jpeg";
import SliderImage3 from "../images/interiorDesginUttardhoka.jpeg";
import "../styles/home.css";
import {Link} from 'react-router'

const MainHero = () => {
  return (
    <div className="carousel-main">
      <div style={{ overflow: "hidden" }} className="carousel-after">
        <Carousel
          indicators={true}
          nextLabel="" // Empty for default text
          prevLabel="" // Empty for default text
          controls={true} // Ensure controls are enabled
          interval={1500}
          className="custom-carousel"
        >
          <Carousel.Item>
            <div
              className="d-flex align-items-center justify-content-center carousel-section"
              style={{
                backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.5)),url(${SliderImage})`,
                backgroundPosition: "center",
              }}
            >
              <div className="text-center text-white">
                <h1>Welcome to <br />Build Force Construction & Service Pvt. Ltd</h1>
                <Link to='/contact-us' className="slider-button">Get a estimation</Link>
              </div>
            </div>
          </Carousel.Item>

          <Carousel.Item>
            <div
              className="d-flex align-items-center justify-content-center carousel-section"
              style={{
                backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.5)),url(${SliderImage2})`,
                backgroundPosition: "center",
              }}
            >
              <div className="text-center text-white">
                <h1>Explore Our More Works and Projects</h1>
                <Link to='contact-us' className="slider-button">Get a estimation</Link>
              </div>
            </div>
          </Carousel.Item>

          <Carousel.Item>
            <div
              className="d-flex align-items-center justify-content-center carousel-section"
              style={{
                backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.5)),url(${SliderImage3})`,
                backgroundPosition: "center",
              }}
            >
              <div className="text-center text-white">
                <h1>Join Us Today and Be a Part of Our Team</h1>
                <Link to='/contact-us' className="slider-button">Get a estimation</Link>
              </div>
            </div>
          </Carousel.Item>
        </Carousel>
      </div>
    </div>
  );
};

export default MainHero;
